
export interface SensorData {
  temp: number;
  humidity: number;
  pmv: number;
  ppd: number;
  power: number;
  energySaving: number;
  outdoorTemp: number;
  outdoorHumidity: number;
  windSpeed: number;
  aqi: number;
  co2: number;          // CO2 concentration (ppm)
  lux: number;          // Illuminance (Lux)
  toe: number;          // Tonnage of Oil Equivalent
  energyIntensity: number; // Energy use per m2
}

export interface SystemLoopData {
  chillerOutlet: number;
  chillerInlet: number;
  bufferTank1: number;
  bufferTank2: number;
  bufferTank3: number;
  bufferTank4: number;
  bufferTank5: number;
  boreHole14: number;
  boreHole9: number;
  pumpState: boolean;
  valveState: boolean;
}

export enum ControlMode {
  AI_AUTO = 'AI 자동제어',
  DECISION_SUPPORT = '의사결정 지원',
  MANUAL = '수동제어'
}

export interface ChatEvidence {
  skill: string;
  label: string;
  source: string;
  status: string;
  observedAt?: string | null;
  retrievedAt?: string | null;
  warnings?: string[];
}

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  chart?: any;
  evidence?: ChatEvidence[];
  groundingStatus?: string;
}
